const validate = values => {
    const errors = {usuario: '', password: ''};
    if (!values.usuario) {
        errors.usuario = 'Debe ingresar un usuario';
    }
    if (!values.password) {
        errors.password = 'Debe ingresar una contraseña';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/ingreso/validate.ts